<ng-template #waitingMenu>
	<ngx-skeleton-loader count="5" [theme]="{'width.px': 62, margin: '0 16px', 'vertical-align': 'middle'}"></ngx-skeleton-loader>
</ng-template>

<mat-sidenav-container hasBackdrop="false">
	<mat-sidenav mode="over" position="end" autoFocus="false" fixedInViewport="true" disableClose #sidenav (onClickOutside)="sidenav.close()" 
        class="app-acrylic app-main-sidenav">
		<div fxLayout="column" style="height: 100%">
			<ng-container *ngIf="isAuthenticated">
				<mat-card class="mat-elevation-z-1" style="padding-top: 12px; margin-right: 16px;">
					<mat-card-header>
						<mat-card-title>{{me?.nomComplet}}</mat-card-title>
						<mat-card-subtitle style="margin-bottom: 0;">{{me?.fonctionAndVille }}</mat-card-subtitle>
						<button fxHide.gt-xs mat-icon-button (click)="sidenav.close()">
							<mat-icon>close</mat-icon>
						</button>
					</mat-card-header>
				</mat-card>
				
				<mat-card class="mat-elevation-z-1">
					<mat-card-actions align="end" fxLayout.xs="column">
						<div fxFlex="1 1 0"></div>
						<button mat-button color="warn" (click)="deconnect()">
							<mat-icon>logout</mat-icon>
							Déconnexion
						</button>
					</mat-card-actions>
				</mat-card>

                <mat-card class="mat-elevation-z0" style="margin: 16px">
                    <mat-card-header>
                        <mat-card-title><mat-icon>assignment_ind</mat-icon> Mon profil</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
						Pour consulter votre profil, modifier vos informations personnelles ainsi que personnaliser votre expérience sur le Portail, vous pouvez également modifier votre mot de passe.
					</mat-card-content>
                    <mat-card-actions align="end">
                        <a mat-button routerLink="/profile" id="profile-button-navigate">
                            Voir mon profil
							<mat-icon>navigate_next</mat-icon>
						</a>
                    </mat-card-actions>
                </mat-card>

				<mat-card class="mat-elevation-z0" style="margin: 16px" *ngIf="me.isImpersonateGod && me.isImpersonate">
					<mat-card-content class="mat-red">
						Ce compte impersonnalisé ne doit être utilisé qu'à des fins de tests par le service développement
					</mat-card-content>
					<mat-card-actions align="end">
						<button mat-button color="warn" (click)="personate()">
							<mat-icon>close</mat-icon>
							Arréter l'imitation
						</button>
					</mat-card-actions>
				</mat-card>
			</ng-container>
		</div>
	</mat-sidenav>
	<mat-sidenav-content [ngStyle.xs]="{overflow: currentNeededMainItem ? 'hidden' : 'auto'}" #sidenavContentElement>
		<mat-toolbar *ngIf="isAuthenticated && !isFramed" #toolbarElement (onClickOutside)="closeMenu()" class="app-acrylic app-sticky app-print-hide"
			[ngClass]="{'mat-toolbar-sidenav-opened': sidenav.opened}">
			<mat-toolbar-row>

				<div fxHide.lt-md class="app-toolbar-environment mat-accent-gradient" *ngIf="isBeta">Beta</div>
				<div fxHide.lt-md class="app-toolbar-environment mat-night-gradient" *ngIf="isDevelopment">Dev</div>
				
				<a fxHide.lt-md matRipple id="menu-home" routerLink="/" style="padding: 0 4px 0 0; border-radius: 28px">
					<img alt="illustration" width="54px" height="54px" loading="lazy" src="assets/logo-app.svg" />
				</a>
                
                <button fxHide.gt-sm mat-icon-button routerLink="/" aria-label="home">
                    <mat-icon>home</mat-icon>
                </button>

				<div *ngIf="menu | async as menu; else waitingMenu" fxLayout="row" class="mat-toolbar-menu mat-primary">
					<ng-container *ngFor="let mainMenuItem of menu; let mainMenuItemIndex = index">
						<button mat-button *ngIf="mainMenuItem.children.length" (click)="toggleMenu(mainMenuItem)" [id]="('menu-'+ mainMenuItem.name).kebabize()">
							{{mainMenuItem.name}}
							<mat-icon inline *ngIf="mainMenuItem.children.length" [@iconExpanded]="currentMainItem?.id === mainMenuItem.id">
								expand_more
							</mat-icon>
						</button>
						<a mat-button *ngIf="mainMenuItem.link" [routerLink]="mainMenuItem.link" [state]="{id: mainMenuItem.id}" [id]="('menu-'+ mainMenuItem.name).kebabize()">
							{{mainMenuItem.name}}
						</a>
					</ng-container>
				</div>
				<div class="mat-toolbar-actions mat-primary">
					<div fxHide.xs fxFlex="1 1 0"></div>

                    <mat-form-field class="mat-form-field-search mat-form-field-without-label mat-form-field-without-hint mat-form-field-inline">
						<input matInput type="search" autocomplete="off"
								placeholder="Rechercher des personnes, établissements, documents, ou des pages du portail..."
								[formControl]="searchControl"
								(focus)="currentMainItem = currentSearch">
						<mat-spinner matPrefix diameter="24" *ngIf="searchState.isWaiting" style="margin-left: .25em;"></mat-spinner>
						<mat-icon matPrefix *ngIf="!searchState.isWaiting">search</mat-icon>
						<button *ngIf="searchControl.value" matSuffix mat-icon-button aria-label="Clear" 
							(click)="currentMainItem = null; searchControl.reset(); $event.stopImmediatePropagation();">
							<mat-icon>close</mat-icon>
						</button>
					</mat-form-field>

					<div fxHide.xs fxFlex="1 1 0"></div>

					<button fxHide.xs mat-flat-button *ngIf="currentMessages.children?.length" (click)="toggleMenu(currentMessages)"
                        [matBadge]="currentMessages.children?.length" matBadgeColor="warn" class="mat-white">
                        Notifications
					</button>

					<button mat-button (click)="toggleMenu(currentSupport)" aria-label="help" id="menu-help">
                        <mat-icon fxHide.gt-xs>contact_support</mat-icon>
                        <span fxHide.xs>Aide</span>
                        <mat-icon inline [@iconExpanded]="currentMainItem?.id === 'support'">
                            expand_more
                        </mat-icon>
					</button>
				
					<button mat-icon-button (click)="openSidenav($event)" aria-label="profile" id="menu-profile" class="mat-toolbar-profile">
						<mat-user-picture [src]="me?.picture | apiUrl" alt="profile"></mat-user-picture>
					</button>
				</div>
			</mat-toolbar-row>
			<mat-toolbar-row [smoothHeight]="currentNeededMainItem + currentMainItem?.children?.length">
				<ng-container [ngSwitch]="currentNeededMainItem">
					<ng-container *ngSwitchCase="'support'">
						<div support inline></div>
					</ng-container>
					<ng-container *ngSwitchCase="'offline'">
						<div>
							<img alt="illustration" fxHide.xs src="assets/236.svg" class="illustration illustration-sm illustration-inline" style="height: 166px; width: auto;" loading="lazy" />
							<div>
								<mat-list>
									<div mat-subheader class="mat-red">
										<mat-icon>wifi_off</mat-icon>
										Hors ligne
									</div>
									<mat-list-item class="mat-red">
										<div matLine>Vous êtes actuellement hors ligne,</div>
										<div matLine>veuillez vérifier votre connexion internet pour continuer à utiliser le Portail.</div>
									</mat-list-item>
								</mat-list>
							</div>
						</div>
					</ng-container>
					<ng-container *ngSwitchCase="'update-available'">
						<div>
							<img alt="illustration" fxHide.xs [attr.src]="'assets/'+ (isUpdateAvailable ? '324' : '127') +'.svg'" 
								class="illustration illustration-sm illustration-inline" style="height: 166px; width: auto;" loading="lazy" />
							<div>
								<mat-list>
									<div mat-subheader *ngIf="isUpdateAvailable" class="mat-accent-gradient">
										<mat-icon>upload</mat-icon>
										Mise à jour
									</div>
									<div mat-subheader *ngIf="!isUpdateAvailable" class="mat-green">
										<mat-icon>download_done</mat-icon>
										A jour
									</div>
									<ng-container [ngSwitch]="currentUpdateAvailable.type">
										<mat-list-item *ngSwitchCase="UpdateType.Application">
											<div matLine>Une mise à jour de l'application est disponible,</div>
											<div matLine>cliquez sur mettre à jour pour beneficier de la dernière version de l'application</div>
										</mat-list-item>
										<mat-list-item *ngSwitchCase="UpdateType.Me">
											<div matLine>Une mise à jour de vos privilèges est disponible,</div>
											<div matLine>cliquez sur mettre à jour pour beneficier de vos nouveaux privilèges</div>
										</mat-list-item>
										<mat-list-item *ngSwitchDefault>
											<div matLine>Vous avez la dernière version disponible de l'application,</div>
											<div matLine>et vos privilèges sont à jours</div>
										</mat-list-item>
									</ng-container>
									<mat-list-item>
										<div fxLayout="row wrap" fxLayoutGap="8px">
											<button mat-flat-button color="primary" *ngIf="isUpdateAvailable" (click)="update()">
												<mat-icon>refresh</mat-icon>
												Mettre a jour
											</button>
											<a mat-button routerLink="/changes" *ngIf="isUpdateAvailableMore">
												Voir les nouveautés
												<mat-icon>navigate_next</mat-icon>
											</a>
										</div>
									</mat-list-item>
								</mat-list>
							</div>
						</div>
					</ng-container>
					<ng-container *ngSwitchCase="'messages'">
						<div *ngIf="currentMessages.children" fxLayout="row">
							<img alt="illustration" fxHide.lt-lg src="assets/221.svg" class="illustration illustration-sm illustration-inline" 
								style="height: 166px; width: auto;" loading="lazy" />
							<mat-list fxLayout="column" fxLayoutAlign="center">
								<mat-list-item *ngFor="let message of currentMessages.children" class="mat-{{message.type?.color}}">
									<mat-icon mat-list-icon fxFlexAlign="start">{{message.type?.icon}}</mat-icon>
									<div matLine *ngFor="let messageLine of message.message.split('\n')" [innerHTML]="messageLine"></div>
								</mat-list-item>
							</mat-list>
						</div>
					</ng-container>
					<ng-container *ngSwitchDefault>
                        <app-menu *ngIf="currentMainItem?.children" [currentItem]="currentItem" [currentMainItem]="currentMainItem" 
                            (onImpersonate)="impersonate($event)"></app-menu>
					</ng-container>
				</ng-container>
				<div class="app-bottom" fxHide 
					[fxShow.xs]="currentMainItem?.children?.length > 0 || ['support', 'messages'].includes(currentMainItem?.id)" 
					[fxShow.gt-xs]="['messages'].includes(currentMainItem?.id)">
					<button mat-icon-button (click)="currentMainItem = null">
						<mat-icon>expand_less</mat-icon>
					</button>
				</div>
			</mat-toolbar-row>
		</mat-toolbar>
		<router-outlet></router-outlet>
	</mat-sidenav-content>
</mat-sidenav-container>